// Central site configuration. Used for canonical URLs, OG metadata, sitemap, and share copy.

export const SITE_URL = "https://lonestarmap.com";
export const SITE_NAME = "LoneStarMap";
export const SITE_TAGLINE = "A free field guide to the Lone Star tick and alpha-gal syndrome.";
export const SITE_DESCRIPTION =
  "A free field guide to the Lone Star tick and alpha-gal syndrome: where the tick lives, when it is active, what to do after a bite, and how to avoid bites. No signup, not medical advice.";

export const DEFAULT_SHARE_TEXT =
  "Lone Star tick bites have been linked to alpha-gal syndrome, a delayed allergy to red meat. A free map and field guide:";

export const TRUST_POINTS = [
  "Free, no signup",
  "Sourced from CDC & published research",
  "Not medical advice",
];

/** Build an absolute URL from a site-relative path. */
export function absUrl(path: string): string {
  if (!path) return SITE_URL;
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}

/** Build the dynamic OG image URL for a page. */
export function ogImageUrl(params: {
  title: string;
  subtitle?: string;
  badge?: string;
  level?: string;
  kind?: "home" | "state" | "guide" | "tickcheck" | "map";
  /** A state slug: the card shows that state's scale, season and map. */
  state?: string;
  /** With `state`, a county slug: the card shows that county's CDC record. */
  county?: string;
}): string {
  const sp = new URLSearchParams();
  sp.set("title", params.title);
  if (params.state) sp.set("state", params.state);
  if (params.state && params.county) sp.set("county", params.county);
  if (params.subtitle) sp.set("subtitle", params.subtitle);
  if (params.badge) sp.set("badge", params.badge);
  if (params.level) sp.set("level", params.level);
  sp.set("kind", params.kind ?? "guide");
  return absUrl(`/api/og?${sp.toString()}`);
}
